import { Component, OnInit, ViewChild, OnDestroy, ElementRef, Renderer2, AfterViewInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { ROUTES } from './sidebar-routes.config';
import { RouteInfo } from "./sidebar.metadata";
import { customAnimations } from "../animations/custom-animations";
import { ConfigService } from '../services/config.service';
import { LayoutService } from '../services/layout.service';
import { UserAccount } from "app/model/user";
import { Role } from "app/model/role";

export class WebPermissions{
  name: string;
}

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  animations: customAnimations
})

export class SidebarComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('toggleIcon', { static: false }) toggleIcon: ElementRef;
  public menuItems: RouteInfo[];
  depth: number;
  activeTitle: string;
  activeTitles: string[] = [];
  expanded: boolean;
  nav_collapsed_open = false;
  logoUrl = 'assets/img/logo.png';
  public config: any = {};
  layoutSub: Subscription;
 
 

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private configService: ConfigService,
    private layoutService: LayoutService
  ) {
    if (this.depth === undefined) {
      this.depth = 0;
      this.expanded = true;
    }

    this.layoutSub = layoutService.customizerChangeEmitted$.subscribe(
      options => {
        if (options) {
          if (options.bgColor) {
            if (options.bgColor === 'white') {
              this.logoUrl = 'assets/img/logo-dark.png';
            } else {
              this.logoUrl = 'assets/img/logo.png';
            }
          }

          if (options.compactMenu === true) {
            this.expanded = false;
            this.renderer.addClass(this.toggleIcon.nativeElement, 'ft-toggle-left');
            this.renderer.removeClass(this.toggleIcon.nativeElement, 'ft-toggle-right');
            this.nav_collapsed_open = true;
          } else if (options.compactMenu === false) {
            this.expanded = true;
            this.renderer.removeClass(this.toggleIcon.nativeElement, 'ft-toggle-left');
            this.renderer.addClass(this.toggleIcon.nativeElement, 'ft-toggle-right');
            this.nav_collapsed_open = false;
          }
        }
      }
    );
  }

  ngOnInit() {
    this.config = this.configService.templateConf;
    this.menuItems = this.generateMenuItems();

    if (this.config.layout.sidebar.backgroundColor === 'white') {
      this.logoUrl = 'assets/img/logo-dark.png';
    } else {
      this.logoUrl = 'assets/img/logo.png';
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.config.layout.sidebar.collapsed !== undefined) {
        if (this.config.layout.sidebar.collapsed === true) {
          this.expanded = false;
          this.renderer.addClass(this.toggleIcon.nativeElement, 'ft-toggle-left');
          this.renderer.removeClass(this.toggleIcon.nativeElement, 'ft-toggle-right');
          this.nav_collapsed_open = true;
        } else if (this.config.layout.sidebar.collapsed === false) {
          this.expanded = true;
          this.renderer.removeClass(this.toggleIcon.nativeElement, 'ft-toggle-left');
          this.renderer.addClass(this.toggleIcon.nativeElement, 'ft-toggle-right');
          this.nav_collapsed_open = false;
        }
      }
    }, 0);
  }

  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
  }

  toggleSlideInOut() {
    this.expanded = !this.expanded;
  }

  handleToggle(titles: string[]) {
    this.activeTitles = titles;
  }

  generateMenuItems(): RouteInfo[] {
    const userJson = localStorage.getItem('user');
    let user: UserAccount = null;
    try {
      user = userJson ? JSON.parse(userJson) : null;
    } catch (e) {
      user = null;
    }

    // Null-safe: a non-admin whose login response has no roles/webModule must NOT
    // crash menu generation (that blanks the whole page). Default to an empty list.
    let stringList: string[] = (user && user.roles && user.roles.webModule) ? user.roles.webModule : [];

    const menuItems: RouteInfo[] = [
      { path: '/dashboard', title: 'Dashboard', icon: 'ft-home', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: 'Dashboard' },
  //     
     // { path: '/organization/createorg', title: 'Organization', icon: 'ft-user', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: 'Organization' },
     // { path: '/cropmaster/createcrop', title: 'Crop Master', icon: 'ft-user', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: 'Corp Master' },
    //  {
    //   path: '/organization/createorg', title: 'Organization', icon: 'ft-user', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,permissionName: 'Corp Master',
    //   submenu: [
    //     { path: '/organization/createorg', title: 'Create Organization', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: '' },
    //     { path: '/organization/orgstructure', title: 'Org Structure', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: '' }
    //   ]
    // },

    {
      path: '/cropmaster/createcrop', title: 'Entity SetUp', icon: 'ft-user', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,permissionName: 'Corp Master',
      submenu: [
        { path: '/cropmaster/createcrop', title: 'Create Entity', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: '' },
        { path: '/cropmaster/mergecrop', title: 'Merge Entity', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: '' },
        { path: '/organization/orgstructure', title: 'Entity Structure', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: '' }
      ]
    },
    {
      path: '/store/createstore', title: 'Store Management', icon: 'ft-user', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,permissionName: 'Store Management',
      submenu: [
        { path: '/store/createstore', title: 'Create Store', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: '' },
        { path: '/store/storelist', title: 'Upload Store', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: '' },
     //   { path: '/store/createlocation', title: 'Add location', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: '' },
      ]
    },
    { path: '', title: 'Role Management ', icon: 'ft-user', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false, permissionName: 'Role Management',
      submenu: [
         { path: '/role/createrole', title: 'Create Role', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: 'Create Role'},

         { path: '/role/webrole', title: 'Web Role', icon: ''  , class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] ,permissionName: 'Web Role'},
         { path: '/role/kioskrole', title: 'Kiosk Role', icon: ''  , class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],permissionName: 'Kiosk Role' },
         
      ] 
 },

   //   { path: '/store/createstore', title: 'Store Management', icon: 'ft-shopping-cart', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: 'Store Management' },
      { path: '/user-management', title: 'User Management', icon: 'ft-user', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: 'User Management' },
      {
        path: '/kiosk/newkiosk', title: 'Kiosk Management', icon: 'ft-user', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,permissionName: 'Kiosk Management',
        submenu: [
          { path: '/kiosk/newkiosk', title: 'Add Kiosk', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: 'Add Kiosk' },
          { path: '/kiosk/bill-validator', title: 'Add Bill Validator', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: 'Add Bill Validator' },
          { path: '/kiosk/printer', title: 'Add Printer', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: 'Add Printer' },
          { path: '/kiosk/locks', title: 'Add Locks', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: 'Add Locks' }
        ]
      },
      {
        path: '/assign/assignstore', title: 'Assign To Store', icon: 'ft-shopping-cart', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,permissionName: 'Assign To Store',
        submenu: [
          { path: '/assign/assignstore', title: 'Assign Device To Store', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: 'Assign Store' },
          // { path: '/assign/assign-user-to-store', title: 'Assign User To Store', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: 'Assign User To Store' },
          // { path: '/assign/assign-permission', title: 'Assign Permissions', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: 'Assign Permission' },
          // { path: '/assign/user-assigning', title: 'User Assigning', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: 'User Assigning' },
           { path: '/assign/assign-user-to-reports', title: 'Assign User To Reports', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: 'Assign User To Reports' },
          { path: '/assign/roles-to-store-assigning', title: 'Assign Roles to Stores', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: 'Role to Store Assigning' }
        ] 
      },
      { path: '/report/createreport', title: 'Reports', icon: 'ft-align-left', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: 'Reports' },
      {
        path: '/settings/change-password', title: 'Settings', icon: 'ft-aperture', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,permissionName: 'Settings',
        submenu: [
          { path: '/settings/change-password', title: 'Change Password', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], permissionName: '' }
        ]
      }
    ];

    return menuItems.filter(menuItem => this.isPermissionsEnable(menuItem.permissionName, stringList));
  }

  isPermissionsEnable(permissionName: string, permissions: any): boolean {
    return permissions.some(permission => permission === permissionName);
  }
}
